export default __webpack_public_path__ + "fac88169424b827f4bbca82bd7a01a9f.png";